import { render, staticRenderFns } from "./AdvisoryDetail.vue?vue&type=template&id=414c44d8"
import script from "./AdvisoryDetail.vue?vue&type=script&lang=js"
export * from "./AdvisoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports